import { axios } from "../config/axios";
import {
  IEsimPartner,
  IEsimPartnerAllocationTopUp,
  IEsimPartnerCreate,
  IEsimPartnerUpdate,
  IEsimPartners
} from "../interfaces/endpoints/IEsimPartner";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import { serialize } from "../utils/serializeToQueryString";

export type getAllEsimPartnersParamsType = {
  pageIndex: number;
  search?: string;
};

export const getAllEsimPartners = async (
  att: getAllEsimPartnersParamsType
): Promise<IAxiosResponse<IEsimPartners>> => {
  return axios.get<IEsimPartners>(`EsimPartner/Partners${serialize(att)}`);
};

export const getEsimPartnerById = async (
  id: number
): Promise<IAxiosResponse<IEsimPartner>> => {
  return axios.get<IEsimPartner>(`EsimPartner/Partner/${id}`);
};

export const createEsimPartner = async (
  body: IEsimPartnerCreate
): Promise<IAxiosResponse<IEsimPartner>> => {
  return axios.post("EsimPartner/Partner", body);
};

export const updateEsimPartner = async (
  body: IEsimPartnerUpdate,
  id: number
): Promise<IAxiosResponse<IEsimPartner>> => {
  return axios.put(`EsimPartner/Partner/${id}`, body);
};

export const deleteEsimPartner = async (id: number): Promise<boolean> => {
  return axios.delete(`EsimPartner/DeletePartner/${id}`);
};

export const topUpEsimPartnerAllocation = async (
  partnerId: number,
  body: IEsimPartnerAllocationTopUp
): Promise<IAxiosResponse<IEsimPartner>> => {
  return axios.post(`EsimPartner/TopUpAllocation/${partnerId}`, body);
};
